<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="search"
            itemText="codeName"
            itemValue="code"
            name="checkTypeCd"
            label="구분"
            codeGroupCd="SOP_SAFETY_TYPE_CD"
            v-model="searchParam.checkTypeCd"
          ></c-select>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            label="점검년월"
            name="month"
            type="month"
            default="today"
            v-model="searchParam.month">
          </c-datepicker>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            stepperGrpCd="SMD_SAFETY_CHECK_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="checkStatusCd"
            label="진행상태"
            v-model="searchParam.checkStatusCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            :isFirstValue="false"
            type="search"
            label="점검부서"
            name="checkDeptCd"
            v-model="searchParam.checkDeptCd">
          </c-dept>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="관리감독자 업무일지 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn v-if="editable" label="등록" icon="add" @btnClicked="linkClick" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "safety-check",
  props: {
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            style: 'width:100px',
            label: "LBLPLANT",
            align: "center",
            sortable: false,
          },
          {
            name: "checkTypeName",
            field: "checkTypeName",
            style: 'width:100px',
            label: "구분",
            align: "center",
            sortable: false,
          },
          {
            name: "safetyCheckName",
            field: "safetyCheckName",
            style: 'width:200px',
            label: "점검명",
            align: "left",
            type: "link",
            sortable: false,
          },
          {
            name: "checkDeptName",
            field: "checkDeptName",
            style: 'width:100px',
            label: "점검부서",
            align: "center",
            sortable: false,
          },
          {
            name: "checkStatusName",
            field: "checkStatusName",
            label: "진행상태",
            style: 'width:100px',
            align: "center",
            sortable: false,
          },
          {
            name: 'approvalStatusName',
            field: 'approvalStatusName',
            label: 'LBL0002204',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
          {
            name: "checkDate",
            field: "checkDate",
            style: 'width:100px',
            label: "점검년월",
            align: "center",
            sortable: false,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        month: '',
        checkStatusCd: null,
        checkTypeCd: 'SST0000001',
        checkDeptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        isFull: true,
        param: {},
        closeCallback: null,
      },
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.safetycheck.plan.list.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(row) {
      this.popupOptions.title = '관리감독자 업무일지 상세';
      this.popupOptions.target = () => import(`${"./safetyCheckDetail.vue"}`);
      this.popupOptions.param = {
        safetyCheckId: row ? row.safetyCheckId : '',
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>